"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "orio-litta": {
    "ab4ba2d7": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "casa-bettolino": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67ead2dd": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "casa-fregabotto": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a75d4dfc": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "casa-padullone": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f8f2fbc5": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "casa-venere": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6833b0b9": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-braglia": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f8a688a4": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-marmora": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0be317ff": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-nuova": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "971d1121": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-san-pietro": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "306f613c": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-villa": [{
      "hkey": "605de1dd",
      "slug": "orio-litta",
      "name": "Orio Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;